function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
}
else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import DeleteButton from '../../Buttons/DeleteButton';
export var EnumDeleteButtonType = /*#__PURE__*/ function (EnumDeleteButtonType) {
    EnumDeleteButtonType["BUTTON"] = "BUTTON";
    EnumDeleteButtonType["ICON"] = "ICON";
    return EnumDeleteButtonType;
}({});
var DeleteModal = /*#__PURE__*/ function (_Component) {
    _inherits(DeleteModal, _Component);
    var _super = _createSuper(DeleteModal);
    function DeleteModal() {
        var _this;
        _classCallCheck(this, DeleteModal);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            show: false,
            title: 'Delete this record?',
            body: ''
        });
        _defineProperty(_assertThisInitialized(_this), "confirm", function () {
            _this.props.onCallBack(_this.props.deleteId);
            _this.switchShow();
        });
        _defineProperty(_assertThisInitialized(_this), "switchShow", function () {
            _this.setState({
                show: !_this.state.show
            });
        });
        _defineProperty(_assertThisInitialized(_this), "btnFactory", function () {
            switch (_this.props.buttonType) {
                case EnumDeleteButtonType.BUTTON:
                    return /*#__PURE__*/ React.createElement(Button, {
                        variant: 'danger',
                        onClick: _this.switchShow,
                        disabled: _this.props.isDisabled,
                        id: "test-users-delete-modal-button-".concat(_this.props.deleteId)
                    }, "Delete");
                case EnumDeleteButtonType.ICON:
                    return /*#__PURE__*/ React.createElement(DeleteButton, {
                        onClick: _this.switchShow,
                        disabled: _this.props.isDisabled,
                        id: _this.props.deleteId
                    });
                default:
                    return /*#__PURE__*/ React.createElement(DeleteButton, {
                        onClick: _this.switchShow,
                        disabled: _this.props.isDisabled,
                        id: _this.props.deleteId
                    });
            }
        });
        return _this;
    }
    _createClass(DeleteModal, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.title) {
                    this.setState({
                        title: this.props.title
                    });
                }
                if (this.props.body) {
                    this.setState({
                        body: this.props.body
                    });
                }
            }
        }, {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ React.createElement(React.Fragment, null, this.btnFactory(), /*#__PURE__*/ React.createElement(Modal, {
                    show: this.state.show,
                    onHide: this.switchShow,
                    id: "users-delete-modal-".concat(this.props.deleteId)
                }, /*#__PURE__*/ React.createElement(Modal.Header, {
                    closeButton: true,
                    id: "test-modal-header"
                }, /*#__PURE__*/ React.createElement(Modal.Title, {
                    id: "test-modal-title"
                }, this.state.title), this.props.link && /*#__PURE__*/ React.createElement("a", {
                    className: "text-decoration-none text-dark ml-2",
                    href: this.props.link,
                    target: "_blank",
                    rel: "noreferrer"
                }, /*#__PURE__*/ React.createElement(AiOutlineInfoCircle, null))), this.state.body ? /*#__PURE__*/ React.createElement(Modal.Body, {
                    id: "test-modal-body"
                }, this.state.body) : '', /*#__PURE__*/ React.createElement(Modal.Footer, {
                    id: "test-modal-footer"
                }, /*#__PURE__*/ React.createElement(Button, {
                    variant: "secondary",
                    onClick: this.switchShow,
                    id: "test-modal-button-close"
                }, "Close"), /*#__PURE__*/ React.createElement(Button, {
                    variant: "primary",
                    onClick: this.confirm,
                    id: "test-modal-button-delete"
                }, "Delete"))));
            }
        }]);
    return DeleteModal;
}(Component);
export default DeleteModal;
